import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  handleExportUnits,
  handleFetchUnits,
  handleUpdateUnitShown,
} from "../../../api/units";
import { message, Table, Tooltip } from "antd";
import Something from "../../../components/shared/Something";
import { ExportToExcel } from "../../../utils/exportExcel";
import { useState } from "react";
import { SlReload } from "react-icons/sl";
import { RiDeleteBinLine, RiFileExcel2Line } from "react-icons/ri";
import { LuPlus, LuShieldClose } from "react-icons/lu";
import { AiOutlineSafetyCertificate } from "react-icons/ai";
import { FiEdit, FiPhoneOutgoing } from "react-icons/fi";
import { TfiEmail } from "react-icons/tfi";

export default function BUnits() {
  const [isExporting, setExporting] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const queryClient = useQueryClient();

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const params = `shown=0`;
  const {
    data: units,
    refetch,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["units"],
    queryFn: () => handleFetchUnits({ params }),
  });

  const { mutate } = useMutation({
    mutationFn: handleUpdateUnitShown,
    onSuccess: () => {
      message.success("Updated Successfully");
      queryClient.invalidateQueries({ queryKey: ["units"] });
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const updateShown = async (_id: any) => {
    mutate({ _id });
  };

  const columns = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">
          {" "}
          {pagination?.page * pagination?.limit - pagination?.limit + index + 1}
        </span>
      ),
    },
    {
      title: "NAME",
      width: 200,
      render: (record: any) => (
        <div className="">
          <span className="text-gray-700">{record?.name || "-"}</span>
        </div>
      ),
    },
    {
      title: "INITIATORS",
      width: 120,
      render: (record: any) => (
        <div className="flex flex-col">
          {record?.approvals?.initiators?.map((approver: any, index: any) => (
            <Tooltip placement="top" title={`${approver?.name}`} key={index}>
              <div
                className="text-gray-600  flex items-center"
                style={{
                  fontSize: 11,
                }}
                key={index}
              >
                <div className="">
                  <TfiEmail color={approver?.email ? "green" : "red"} />
                </div>
                <div className="mx-1">
                  <FiPhoneOutgoing color={approver?.mobile ? "green" : "red"} />
                </div>
                <div className="">{approver?.name}</div>
              </div>
            </Tooltip>
          ))}
        </div>
      ),
    },
    {
      title: "LINE MANAGERS",
      width: 120,
      render: (record: any) => (
        <div className="flex flex-col">
          {record?.approvals?.lineManagers?.map((approver: any, index: any) => (
            <Tooltip placement="top" title={`${approver?.name}`} key={index}>
              <div
                className="text-gray-600  flex items-center"
                style={{
                  fontSize: 11,
                }}
                key={index}
              >
                <div className="">
                  <TfiEmail color={approver?.email ? "green" : "red"} />
                </div>
                <div className="mx-1">
                  <FiPhoneOutgoing color={approver?.mobile ? "green" : "red"} />
                </div>
                <div className="">{approver?.name}</div>
              </div>
            </Tooltip>
          ))}
        </div>
      ),
    },
    {
      title: "FINANCIAL CONTROLLERS",
      width: 120,
      render: (record: any) => (
        <div className="flex flex-col">
          {record?.approvals?.financialControllers?.map(
            (approver: any, index: any) => (
              <Tooltip placement="top" title={`${approver?.name}`} key={index}>
                <div
                  className="text-gray-600  flex items-center"
                  style={{
                    fontSize: 11,
                  }}
                  key={index}
                >
                  <div className="">
                    <TfiEmail color={approver?.email ? "green" : "red"} />
                  </div>
                  <div className="mx-1">
                    <FiPhoneOutgoing
                      color={approver?.mobile ? "green" : "red"}
                    />
                  </div>
                  <div className="">{approver?.name}</div>
                </div>
              </Tooltip>
            )
          )}
        </div>
      ),
    },
    {
      title: "BUSINESS UNIT HEADS",
      width: 120,
      render: (record: any) => (
        <div className="flex flex-col">
          {record?.approvals?.businessUnitHeads?.map(
            (approver: any, index: any) => (
              <Tooltip placement="top" title={`${approver?.name}`} key={index}>
                <div
                  className="text-gray-600  flex items-center"
                  style={{
                    fontSize: 11,
                  }}
                  key={index}
                >
                  <div className="">
                    <TfiEmail color={approver?.email ? "green" : "red"} />
                  </div>
                  <div className="mx-1">
                    <FiPhoneOutgoing
                      color={approver?.mobile ? "green" : "red"}
                    />
                  </div>
                  <div className="">{approver?.name}</div>
                </div>
              </Tooltip>
            )
          )}
        </div>
      ),
    },
    {
      title: "EXECUTIVES",
      width: 120,
      render: (record: any) => (
        <div className="flex flex-col">
          {record?.approvals?.executives?.map((approver: any, index: any) => (
            <Tooltip placement="top" title={`${approver?.name}`} key={index}>
              <div
                className="text-gray-600  flex items-center"
                style={{
                  fontSize: 11,
                }}
                key={index}
              >
                <div className="">
                  <TfiEmail color={approver?.email ? "green" : "red"} />
                </div>
                <div className="mx-1">
                  <FiPhoneOutgoing color={approver?.mobile ? "green" : "red"} />
                </div>
                <div className="">{approver?.name}</div>
              </div>
            </Tooltip>
          ))}
        </div>
      ),
    },

    {
      title: "SHOWN",
      width: 60,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.isShown ? (
            <button
              onClick={() => updateShown(record?._id)}
              className="text-green-600 flex items-center"
            >
              <div className="flex items-center">
                <AiOutlineSafetyCertificate size={18} />{" "}
                <span className="mx-1">YES</span>
              </div>
            </button>
          ) : (
            <button
              onClick={() => updateShown(record?._id)}
              className="text-red-600 flex items-center"
            >
              <LuShieldClose size={18} /> <span className="mx-1">NO</span>
            </button>
          )}
        </span>
      ),
    },
    {
      title: "ACTION",
      width: 100,
      render: (record: any) => (
        <div className="flex justify-end">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              // setUpdateModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-yellow-100 hover:bg-yellow-200"
          >
            <FiEdit />
          </button>

          <button
            onClick={() => {
              setSelected({
                ...record,
              });
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-not-allowed"
          >
            <RiDeleteBinLine color="red" />
          </button>
        </div>
      ),
    },
  ];

  const exportUnits = async () => {
    setExporting(true);
    const users = await handleExportUnits();
    await ExportToExcel(
      users?.map((item: any) => {
        return {
          EMP_ID: item?.empId || "-",
          EMAIL: item?.email || "-",
          FULLNAME: item?.name || "-",
          BUSINESS_UNIT: item?.businessUnit || "-",
          LEGAL_ENTITY: item?.legalEntity || "-",
          MOBILE: item?.mobile || "-",
        };
      }),
      "Business Units.xlsx"
    );
    setExporting(false);
  };

  return (
    <div className="">
      <div className="bg-white m-1">
        <div className="flex flex-col sm:flex-row justify-between border-b p-2">
          <div className="">
            <div className="font-bold">Business Units</div>
            <div className="text-gray-600">Manage Business Units</div>
          </div>

          <div className="flex">
            <Tooltip title="Export To Excel">
              <button
                className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
                onClick={() => exportUnits()}
              >
                {isExporting ? <SlReload /> : <RiFileExcel2Line size={20} />}
              </button>
            </Tooltip>

            <button
              className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
            >
              <LuPlus size={18} /> <span className="mx-2">New</span>
            </button>
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="">
            <Table
              size="small"
              dataSource={units?.records}
              columns={columns}
              rowKey="id"
              style={{ fontSize: "12px" }}
              pagination={false}
              bordered
            />
          </div>
        )}
      </div>
    </div>
  );
}
